// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"bb6261f8","71":"ecbe7783","184":"91872b11","246":"bfa38125","354":"02a25724","515":"d779666d","522":"52eee967","576":"2b7bfe55","674":"7e2f9e1b","697":"100b6d0d","979":"102e81a9"}[chunkId] + ".chunk.js";
};